import { convertToDateTime } from '@reg/shared/helper/dateTime-helper';
import { IdentityIneligibleReason } from '@reg/shared/model';

/**
 * Model to hold a body assessment ineligibility record
 */
export class IdentityBodyAssessIneligible {
    public id: string = null;
    public isActive: boolean;
    public startDateTime: Date = null;
    public endDateTime: Date = null;
    public bodyAssessmentId: string = null;
    public issuedBy: string = 'coach';
    public ineligibleReason: IdentityIneligibleReason = null;

    public getIsIssuedByOrganization(): boolean {
        return this.issuedBy === 'organization';
    }

    public clone(): IdentityBodyAssessIneligible {
        const clone: IdentityBodyAssessIneligible = new IdentityBodyAssessIneligible();
        clone.id = this.id;
        clone.isActive = this.isActive;
        clone.bodyAssessmentId = this.bodyAssessmentId;
        clone.issuedBy = this.issuedBy;

        if (this.startDateTime) {
            clone.startDateTime = new Date(this.startDateTime.getTime());
        }
        if (this.endDateTime) {
            clone.endDateTime = new Date(this.endDateTime.getTime());
        }

        if (this.ineligibleReason) {
            clone.ineligibleReason = this.ineligibleReason.clone();
        }

        return clone;
    }

    /**
     * Serialize to a json api format
     * @returns {string}
     */
    public serialize(): string {
        const json: any = {};
        json.data = {};
        json.data.type = 'bodyAssessmentIneligible';
        json.data.attributes = {};
        json.data.relationships = {};

        json.data.id = this.id;
        json.data.attributes.startDateTimeUtc = this.startDateTime.toISOString();
        json.data.attributes.endDateTimeUtc = null;
        json.data.attributes.issuedBy = this.issuedBy;

        if (this.endDateTime) {
            json.data.attributes.endDateTimeUtc = this.endDateTime.toISOString();
        }

        if (this.ineligibleReason) {
            const ineligibleReason: any = {};
            ineligibleReason.data = { type: 'ineligibleReason', id: this.ineligibleReason.id };
            json.data.relationships.ineligibleReason = ineligibleReason;
        }

        return JSON.stringify(json);
    }

    /**
     * Deserialize from json api format
     */
    public deserialize(json: Object, included: Object[] = null): IdentityBodyAssessIneligible {
        const data: Object = json['data'] || json;
        const attrs: Object = data['attributes'];
        included = included || json['included'];
        const relationships: Object[] = data['relationships'] || [];

        this.id = data['id'];
        this.startDateTime = convertToDateTime(attrs['startDateTime']);
        if (attrs['endDateTime']) {
            this.endDateTime = convertToDateTime(attrs['endDateTime']);
        }
        this.isActive = attrs['isActive'];
        this.bodyAssessmentId = attrs['bodyAssessmentId'];
        this.issuedBy = attrs['issuedBy'];

        const ineligibleReasonLink: Object = relationships['ineligibleReason'];
        if (ineligibleReasonLink &&
            included &&
            ineligibleReasonLink['data'] &&
            ineligibleReasonLink['data']['id']) {
            const ineligibleReasonId: string = ineligibleReasonLink['data']['id'];
            const ineligibleReasons: Object[] =
                included.filter((i: Object) => i['id'] === ineligibleReasonId);

            if (ineligibleReasons.length === 1) {
                this.ineligibleReason = (new IdentityIneligibleReason()).deserialize(ineligibleReasons[0]);
            }
        } else if (attrs['ineligibleReasonId']) {
            this.ineligibleReason = new IdentityIneligibleReason();
            this.ineligibleReason.id = attrs['ineligibleReasonId'];
        }

        return this;
    }
}
